import { render, staticRenderFns } from "./CreatefromInventory.vue?vue&type=template&id=4d678c3a&"
import script from "./CreatefromInventory.vue?vue&type=script&lang=js&"
export * from "./CreatefromInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports